import { graphql } from 'react-relay';

export const myUserQuery = graphql`
  query mySectionUserQuery {
    bznavRefund {
      user {
        name
        email
        indis {
          refundStatus
          refundStage
          cancelStage
        }
        previousIndis {
          refundStatus
          refundStage
          cancelStage
        }
        corps {
          refundStatus
          refundStage
          cancelStage
        }
      }
    }
  }
`;
